import React, { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";

const API_BASE = "https://eluvent.com/api";

const StudentDashboard = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const [weakAreas, setWeakAreas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!sessionId) {
      setLoading(false);
      return;
    }
    axios.post(`${API_BASE}/student/weak-areas`, { session_id: sessionId })
      .then(res => setWeakAreas(res.data.weak_areas || []))
      .catch(() => console.error("Failed to load weak areas"))
      .finally(() => setLoading(false));
  }, [sessionId]);

  const getStrengthLabel = (percentage) => {
    if (percentage >= 80) return { emoji: "💪", text: "Super strong!", color: "#10b981" };
    if (percentage >= 60) return { emoji: "👍", text: "Doing good, keep it up!", color: "#f59e0b" };
    if (percentage >= 40) return { emoji: "📘", text: "Needs a little more practice", color: "#f97316" };
    return { emoji: "🎯", text: "Focus area – let's improve together!", color: "#ef4444" };
  };

  if (!sessionId) {
    return (
      <div style={{ maxWidth: "600px", margin: "100px auto", textAlign: "center", fontFamily: "Nunito, sans-serif" }}>
        <h2>📊 No session ID provided</h2>
        <p>Please access your dashboard from the main chat page.</p>
        <Link to="/" style={{ color: "#fca311", textDecoration: "none", fontWeight: "700" }}>← Back to Chat</Link>
      </div>
    );
  }

  if (loading) return <div style={{ textAlign: "center", padding: 40 }}>Loading...</div>;

  return (
    <div style={{ maxWidth: "800px", margin: "30px auto", padding: "20px", fontFamily: "Nunito, sans-serif" }}>
      <h1 style={{ textAlign: "center", color: "#1e293b" }}>🎓 My Progress</h1>

      <div style={{ background: "white", borderRadius: 20, padding: 20, boxShadow: "0 2px 8px rgba(0,0,0,0.04)", marginBottom: 20 }}>
        <h3 style={{ color: "#fca311", margin: "0 0 12px" }}>📊 Topic‑wise Performance</h3>
        {weakAreas.length === 0 && (
          <div style={{ color: "#94a3b8", textAlign: "center", padding: "20px 0" }}>
            <p style={{ fontSize: 18 }}>No test results yet.</p>
            <p>Take a topic test to discover your strengths and areas to work on!</p>
            <Link to="/" style={{ color: "#fca311", fontWeight: 700 }}>Go to chat and click 📝 Test</Link>
          </div>
        )}
        {weakAreas.map((area, idx) => {
          const strength = getStrengthLabel(area.percentage);
          return (
            <div key={idx} style={{ marginBottom: 20, padding: "12px", background: "#f8fafc", borderRadius: 12 }}>
              <div style={{ display: "flex", justifyContent: "space-between", fontSize: 14, marginBottom: 6 }}>
                <span style={{ fontWeight: 600 }}>{area.subject} – {area.chapter.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase())}</span>
                <span style={{ fontWeight: 700, color: strength.color }}>{area.percentage}%</span>
              </div>
              <div style={{ width: "100%", height: 10, background: "#e2e8f0", borderRadius: 5, overflow: "hidden" }}>
                <div
                  style={{
                    width: `${area.percentage}%`,
                    height: "100%",
                    background: strength.color,
                    borderRadius: 5
                  }}
                />
              </div>
              <div style={{ marginTop: 8, display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: 20 }}>{strength.emoji}</span>
                <span style={{ fontSize: 13, color: "#475569" }}>{strength.text}</span>
              </div>
            </div>
          );
        })}
      </div>

      {weakAreas.length > 0 && (
        <div style={{ textAlign: "center", marginTop: 10 }}>
          <Link to="/" style={{ display: "inline-block", padding: "10px 20px", background: "#fca311", color: "white", borderRadius: 30, textDecoration: "none", fontWeight: 700 }}>
            ← Back to Chat
          </Link>
        </div>
      )}
    </div>
  );
};

export default StudentDashboard;